import { render, staticRenderFns } from "./DocumentDialog.vue?vue&type=template&id=5b96a5a6&scoped=true"
import script from "./DocumentDialog.vue?vue&type=script&lang=js"
export * from "./DocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentDialog.vue?vue&type=style&index=0&id=5b96a5a6&scoped=true&lang=css"
import style1 from "./DocumentDialog.vue?vue&type=style&index=1&id=5b96a5a6&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b96a5a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b96a5a6')) {
      api.createRecord('5b96a5a6', component.options)
    } else {
      api.reload('5b96a5a6', component.options)
    }
    module.hot.accept("./DocumentDialog.vue?vue&type=template&id=5b96a5a6&scoped=true", function () {
      api.rerender('5b96a5a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/document/DocumentDialog.vue"
export default component.exports